import React from 'react'
import Calendar from 'widgets/shifts/themes/calendar/Calendar'
import ScheduleSummaryOverview from 'widgets/shifts/themes/calendar/ScheduleSummaryOverview'
import { WhenTheme } from 'widgets/theme-switcher'

export default function ScheduleCalendarTheme ({ mode = 'view' }) {
  return (
    <WhenTheme type='calendar'>
      <div className='overflow-x-auto w-full border-t border-gray-200 px-2'>
        <Calendar mode={mode} />
        {/* mode === 'plan'
          ? (
            <ScheduleSummaryOverview />
            )
          : null */}
      </div>
    </WhenTheme>
  )
}
